var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRegistrationSummary = function SvgRegistrationSummary(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 74.3 82.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".attendee-summary-1{fill:url(#radial-gradient);}.attendee-summary-2{fill:url(#radial-gradient-2);}.attendee-summary-3{fill:url(#radial-gradient-3);}.attendee-summary-4{fill:url(#radial-gradient-4);}.attendee-summary-5{fill:url(#radial-gradient-5);}.attendee-summary-6{fill:url(#radial-gradient-6);}.attendee-summary-7{fill:url(#radial-gradient-7);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1.39,
    cy: 78.95,
    r: 1,
    gradientTransform: "matrix(120.1, 89.22, 714.41, -961.63, -56576.35, 75766.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f11e37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10015"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1.5,
    cy: 78.7,
    r: 1,
    gradientTransform: "matrix(108.66, 99.27, 145.74, -159.53, -11631.24, 12403.35)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 6.18,
    cy: 78.67,
    r: 1,
    gradientTransform: "matrix(37.95, 44.32, 44.32, -37.95, -3709.39, 2723.53)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4.08,
    cy: 78.63,
    r: 1,
    gradientTransform: "matrix(55.11, 57.91, 77.72, -73.96, -6301.6, 5600.11)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.83,
    cy: 78.93,
    r: 1,
    gradientTransform: "matrix(132.06, 138.86, 269.77, -256.56, -21414.81, 20114.46)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 1.37,
    cy: 78.93,
    r: 1,
    gradientTransform: "matrix(125.82, 67.36, 709.32, -1324.89, -56169.82, 104526.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 6.91,
    cy: 78.64,
    r: 1,
    gradientTransform: "matrix(42.63, 25.41, 204.92, -343.84, -16389.46, 26933.68)",
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-1",
    d: "M10.83,6.53v4H64.42v-8H10.83Zm4.62,0V7.8H13.21V5.25h2.24Zm4.75,0V7.8H17.83V5.25H20.2Zm4.62,0V7.8H22.45V5.25h2.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-2",
    d: "M10.83,34.36V55.51H64.42V13.21H10.83ZM26.49,16.13A6.72,6.72,0,0,1,30,19.63a17,17,0,0,1,.45,6.81,7.68,7.68,0,0,1-1.63,3.31c-.35.41-.59.78-.53.86s1.07.43,2.23.82a23.29,23.29,0,0,1,2.7,1A7.19,7.19,0,0,1,35.63,35c.68,1.36.81,2.17.81,4.87v2.44H13.18l.05-2.82,0-2.82.49-1.12a6.31,6.31,0,0,1,2.65-3.1,22.48,22.48,0,0,1,2.84-1.09c1.39-.45,2-.71,2-.86a1.24,1.24,0,0,0-.38-.58A7.45,7.45,0,0,1,19.29,27,9.72,9.72,0,0,1,19,23.8c0-3.33.41-4.65,1.93-6.24A5.29,5.29,0,0,1,24,15.92,4.59,4.59,0,0,1,26.49,16.13Zm35.56,1v1.35H38.82v-2.7H62.05Zm0,5.32v1.28H38.82V21.16H62.05Zm-7,5.33v1.35H38.82v-2.7H55.05Zm7,14.48V52.81H38.82V31.66H62.05Zm-25.61,4v1.35H13.21v-2.7H36.44Zm0,5.33v1.27H13.21V50.26H36.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-3",
    d: "M23.9,18.59a3.94,3.94,0,0,0-2.27,2.24,7,7,0,0,0-.33,2.25c-.12,2.83.31,4.24,1.65,5.26l.68.53v3.82l-.68.23-2.88.93c-2.44.78-2.94,1-3.56,1.74a4.61,4.61,0,0,0-1,2.91l-.08,1.11H34.23l-.07-1a4.74,4.74,0,0,0-.93-2.87c-.69-.89-.95-1-3.38-1.82l-2.94-1-.9-.3V28.82l.4-.24a4.43,4.43,0,0,0,1.59-2,7.52,7.52,0,0,0,.25-2.8c0-2.09,0-2.16-.4-3.06A5.4,5.4,0,0,0,27,19.36,3.22,3.22,0,0,0,23.9,18.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-4",
    d: "M41.09,42.27l0,7.92,9.34,0,9.33,0V34.36H41.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-5",
    d: "M6,21.47A3.86,3.86,0,0,0,4.1,23.66c-.27.8-.27,1.2-.27,19V60.76H71.42V42.61c0-17.75,0-18.15-.26-18.95a3.46,3.46,0,0,0-3.4-2.5h-1V58.21H8.45v-37H7.5A3.14,3.14,0,0,0,6,21.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-6",
    d: "M3.86,66c0,2.31.07,2.58.36,3.23A3.59,3.59,0,0,0,5.81,71l.6.34H68.85l.62-.36a3.55,3.55,0,0,0,1.58-1.81c.28-.62.31-.9.34-3.2l0-2.5H3.82Zm7,1.47v1.28H8.45V66.17h2.38Zm4.62,0v1.28H13.21V66.17h2.24Zm4.75,0v1.28H17.83V66.17H20.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-summary-7",
    d: "M24.82,75.39v1.28H20.2v2.7H55.05v-2.7H50.43V74.12H24.82Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistrationSummary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RegistrationSummary.c2c453cd.svg";
export { ForwardRef as ReactComponent };